// extracted by mini-css-extract-plugin
module.exports = {"container":"GenericCarousel-module--container--83d4c3","item":"GenericCarousel-module--item--379f6e"};